// extracted by mini-css-extract-plugin
export default {"alertBox":"customer-service-message_alertBox__mUBMC","alertText":"customer-service-message_alertText__KJmed"};